import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { CalloutPlacement } from '@freelancer/ui/callout';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { TagColor, TagSize } from '@freelancer/ui/tag';
import { FreightlancerNavigationLink } from '../../../../navigation.model';

@Component({
  standalone: false,
  selector: 'app-freightlancer-post-role-select',
  template: `
    <fl-callout
      [bigBorderRadius]="true"
      [edgeToEdge]="true"
      [hideCloseButton]="true"
      [placement]="CalloutPlacement.BOTTOM_RIGHT"
    >
      <fl-callout-trigger>
        <fl-button
          i18n="Navigation primary post button"
          flTrackingLabel="FreightlancerPostCalloutTrigger"
          [color]="ButtonColor.PRIMARY"
          [size]="ButtonSize.SMALL"
        >
          Post
          <fl-icon
            [color]="IconColor.INHERIT"
            [name]="'ui-chevron-down'"
            [size]="IconSize.SMALL"
            [useIconFont]="true"
          />
        </fl-button>
      </fl-callout-trigger>
      <fl-callout-content>
        <div
          class="Cards"
          flTrackingSection="FreightlancerPostRoleSelect"
        >
          <fl-button
            class="Card"
            flTrackingLabel="PostAsShipperCard"
            [display]="'block'"
            [link]="FreightlancerNavigationLink.POST_LOAD"
          >
            <fl-icon
              class="mb-xxsmall"
              [color]="IconColor.PRIMARY"
              [name]="'ui-package-2'"
              [size]="IconSize.LARGE"
              [useIconFont]="true"
            />
            <h2
              class="text-body-20 font-bold mb-xxsmall"
              i18n="Post a load card title"
            >
              Post a Load
            </h2>
            <p
              class="text-body-16 mb-xsmall"
              i18n="Post a load card description"
            >
              Post your load and get bids from available carriers.
            </p>
            <fl-tag
              [color]="TagColor.SECONDARY"
              [size]="TagSize.MID"
              i18n="Post a load card audience label"
            >
              For Shippers
            </fl-tag>
          </fl-button>
          <fl-button
            class="Card"
            flTrackingLabel="PostAsCarrierCard"
            [display]="'block'"
            [link]="FreightlancerNavigationLink.POST_AVAILABILITY"
          >
            <fl-icon
              class="mb-xxsmall"
              [color]="IconColor.PRIMARY"
              [name]="'ui-arrow-outward'"
              [size]="IconSize.LARGE"
              [useIconFont]="true"
            />
            <h2
              class="text-body-20 font-bold mb-xxsmall"
              i18n="Post a trip card title"
            >
              Post a Trip
            </h2>
            <p
              class="text-body-16 mb-xsmall"
              i18n="Post a trip card description"
            >
              Post your trip and find loads along your route.
            </p>
            <fl-tag
              [color]="TagColor.SECONDARY"
              [size]="TagSize.MID"
              i18n="Post a trip card audience label"
            >
              For Carriers
            </fl-tag>
          </fl-button>
        </div>
      </fl-callout-content>
    </fl-callout>
  `,
  styleUrls: ['./freightlancer-post-role-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreightlancerPostRoleSelectComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  CalloutPlacement = CalloutPlacement;
  FreightlancerNavigationLink = FreightlancerNavigationLink;
  IconColor = IconColor;
  IconSize = IconSize;
  TagColor = TagColor;
  TagSize = TagSize;
}
